/*
 * Stratus — Video Band controls (st-product-video.js), sections/st-product-video.liquid
 *
 * - The markup carries no autoplay: playback starts here, and only when the visitor allows motion. Under
 *   prefers-reduced-motion the film stays on its poster until the visitor presses play.
 * - Pause / play button: a flag on the frame swaps the glyph, the aria-label follows the action the button will
 *   take (strings from locales, stratus.product.*). The film is muted and has no sound button.
 * - The film pauses while off screen and resumes when back, unless the visitor paused it.
 * No dependencies.
 */
(function () {
  'use strict';
  if (window.stProductVideo) return; // loaded once per page, whatever the number of sections
  window.stProductVideo = true;

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setup(frame) {
    if (frame.hasAttribute('data-st-video-ready')) return;
    frame.setAttribute('data-st-video-ready', '');

    var video = frame.querySelector('[data-st-video]');
    if (!video) return;
    var controls = frame.querySelector('[data-st-video-controls]');
    var toggle = frame.querySelector('[data-st-video-toggle]');
    var userPaused = false;

    function sync() {
      var paused = video.paused;
      frame.toggleAttribute('data-st-paused', paused);
      if (toggle) toggle.setAttribute('aria-label', toggle.getAttribute(paused ? 'data-label-play' : 'data-label-pause'));
    }

    function play() {
      var promise = video.play();
      if (promise && promise.catch) promise.catch(sync);
    }

    if (REDUCED.matches) userPaused = true;

    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);

    if (toggle) {
      toggle.addEventListener('click', function () {
        if (video.paused) {
          userPaused = false;
          play();
        } else {
          userPaused = true;
          video.pause();
        }
      });
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            if (!userPaused && video.paused) play();
          } else if (!video.paused) {
            video.pause();
          }
        });
      }, { threshold: 0.1 }).observe(frame);
    } else if (!userPaused) {
      play();
    }

    if (controls) controls.hidden = false;
    sync();
  }

  function init(root) {
    var frames = (root || document).querySelectorAll('[data-st-video-band]');
    for (var i = 0; i < frames.length; i++) setup(frames[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
